export const getPackageName = function() {
    // eslint-disable-next-line no-undef
    return __PACKAGE_NAME__;
};

export const getPackageVersion = function() {
    // eslint-disable-next-line no-undef
    return __PACKAGE_VERSION__;
};
